<app-dashboard-card>
  <ng-container card-title-icon>
    <mat-icon>checklist</mat-icon>
  </ng-container>

  <ng-container card-title-content>
    <div class="header-container">
      <h2>{{ title }}</h2>
      @if (showSeeAllLink) {
        <a class="see-all" [routerLink]="['/my-sales']">> Ver todos</a>
      }
    </div>
  </ng-container>

  <ng-container card-content>
    @if (sales) {
      <p-table [value]="sales.data" class="last-sales-table">
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th>Evento</th>
            <th class="d-none d-sm-none d-md-table-cell">Comprador</th>
            <th class="d-none d-sm-none d-md-table-cell">Método de Pagamento</th>
            <th>Quantidade</th>
            <th>Valor</th>
            <th>Status</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sale>
          <tr>
            <td>
              <div class="event-image">
                <app-event-image [thumbnail]="sale.events[0].thumbnail" />
              </div>
            </td>
            <td>
              <div class="col-value event-name">{{ sale.events[0].title }}</div>
            </td>
            <td class="d-none d-sm-none d-md-table-cell">
              <div class="col-name">{{ sale.buyer }}</div>
            </td>
            <td class="d-none d-sm-none d-md-table-cell">
              <div class="col-value">{{ sale.payment_method | paymentMethod }}</div>
            </td>
            <td>
              <div class="col-value">{{ sale.quantity }}</div>
            </td>
            <td>
              <div class="col-value">{{ sale.total | currency: "BRL" }}</div>
            </td>
            <td>
              <span class="status status--{{ (sale.payment_status | paymentStatus).toLowerCase() }}">
                {{ sale.payment_status | paymentStatus }}
              </span>
            </td>
            <td>
              <button mat-icon-button aria-label="Detalhar pedido" (click)="saleDetailsClick.emit(sale.order_id)">
                <mat-icon>visibility_outlined</mat-icon>
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" class="col-value">Você ainda não possui nenhuma venda realizada.</td>
          </tr>
        </ng-template>
      </p-table>

      @if (showPagination && sales.meta.total_count > 0) {
        <p-paginator
          [first]="first"
          [rows]="rows"
          [totalRecords]="sales.meta.total_count"
          (onPageChange)="handlePageChange($event)"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [showPageLinks]="false"
          [showFirstLastIcon]="false"
          [rowsPerPageOptions]="[5, 10, 20, 50]"
          [appendTo]="'body'" />
      }
    } @else {
      <p-skeleton height="20rem" />
    }
  </ng-container>
</app-dashboard-card>
